exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ReportContent__reportContent__1FSZZv,\n.ReportContent__reportJSON__1-J5xk {\n  background: light-bg-gray;\n}\n.ReportContent__reportContent__1FSZZv {\n  border: none;\n  flex: 1;\n  overflow: auto;\n}\n.ReportContent__reportContent__1FSZZv pre {\n  border: none;\n  font-family: 'SplunkDataSans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  overflow: auto;\n  margin: 0;\n  padding: 10px;\n  white-space: pre-wrap;\n}\n.ReportContent__reportContent__1FSZZv pre span {\n  color: #528bff;\n  font-weight: 500;\n}\n.ReportContent__reportJSON__1-J5xk {\n  padding: 5px;\n  overflow-x: scroll;\n}\n.ReportContent__reportJSON__1-J5xk div {\n  padding: 0;\n  font-weight: normal;\n  font-size: 12px;\n}\n.ReportContent__reportJSON__1-J5xk a {\n  color: #40e0d0;\n  text-decoration: none;\n}\n.ReportContent__reportJSON__1-J5xk a:hover {\n  color: #eebd31;\n  text-decoration: underline;\n}\n.dark .ReportContent__reportContent__1FSZZv,\n.dark .ReportContent__reportJSON__1-J5xk {\n  background: #1a1c20;\n}\n", ""]);

// exports
exports.locals = {
	"reportContent": "ReportContent__reportContent__1FSZZv",
	"reportJSON": "ReportContent__reportJSON__1-J5xk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/ReportContent.styl
// module id = 3625
// module chunks = 39